// extracted by mini-css-extract-plugin
export var anchored = "ApplicationAndBranchListing-module--anchored--21610";
export var applicationTeaser = "ApplicationAndBranchListing-module--applicationTeaser--3a0be";
export var container = "ApplicationAndBranchListing-module--container--5af66";